import { Injectable } from '@angular/core';
import { AESService } from '../aes/aes.service';

@Injectable({
    providedIn: 'root'
})
export class Base64Service {

    constructor(private aesService: AESService) { }

    encode(value: string): string {
        const encrypted = this.aesService.encrypt(value);
        const encoded = btoa(encrypted) // Standard Base64
            .replace(/\+/g, '-') // Replace '+' with '-'
            .replace(/\//g, '_') // Replace '/' with '_'
            .replace(/=+$/, ''); // Remove trailing '='

        return encoded;
    }

    decode(value: string): string {
        const base64 = value
            .replace(/-/g, '+') // Replace '-' back to '+'
            .replace(/_/g, '/'); // Replace '_' back to '/'

        try {
            const decryptedBase64 = atob(base64);
            return this.aesService.decrypt(decryptedBase64);
        } catch (e) {
            // console.error('Invalid Base64 string:', value);
            return '';
        }
    }
}
